import React from "react";

const ProjectCard = ({
  title,
  subtitle,
  description,
  date,
  link,
  secondaryLink,
  secondaryText,
  image,
}) => {
  return (
    <div className="bg-text-default shadow-md rounded-lg overflow-hidden flex flex-col md:flex-row">
      {/* Left: Image */}
      {image && (
        <div className="w-1/4 md:w-1/3 flex-shrink-0">
          <img src={image} alt={title} className="h-full w-full object-cover" />
        </div>
      )}

      {/* Right: Content */}
      <div className="p-6 flex-1 flex flex-col justify-between">
        {/* Header */}
        <div className="flex justify-between items-start mb-2">
          <div className="text-left">
            <h3 className="text-xl font-semibold">{title}</h3>
            {subtitle && <p className="text-color-sub">{subtitle}</p>}
          </div>
          {date && (
            <p className="text-sm text-gray-500 ml-4 whitespace-nowrap">
              {date}
            </p>
          )}
        </div>

        {/* Description */}
        <p className="text-gray-700 mb-4 text-left">{description}</p>

        {/* Buttons */}

        <div className="flex justify-center space-x-4">
          {link && (
            <a
              href={link}
              className="bg-accent1-default text-white hover:bg-accent2-default px-4 py-2 rounded transition duration-300"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Project
            </a>
          )}
          {secondaryLink && secondaryText && (
            <a
              href={secondaryLink}
              className="bg-green-600 text-white hover:bg-green-700 px-4 py-2 rounded transition duration-300"
              target="_blank"
              rel="noopener noreferrer"
            >
              {secondaryText}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
